import { useEffect } from 'react';

/**
 * Set the document title for the current page
 * @param {string} title - The page title to display
 */
const usePageTitle = (title) => {
  useEffect(() => {
    const previousTitle = document.title;
    document.title = title;
    
    return () => {
      document.title = previousTitle;
    };
  }, [title]);
};

/**
 * Component to set page title
 */
const PageTitle = ({ title }) => {
  usePageTitle(title);
  return null;
};

export { usePageTitle, PageTitle };
export default PageTitle;
